import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import SeasonBanner from "../components/SeasonBanner";
import PresentationSection from "../components/PresentationSection";
import GardenSection from "../components/GardenSection";
import AmenitiesSection from "../components/AmenitiesSection";
import ActivitiesSection from "../components/ActivitiesSection";
import PricingSection from "../components/PricingSection";
import ReviewsSection from "../components/ReviewsSection";
import FAQSection from "../components/FAQSection";
import ContactFormSection from "../components/ContactFormSection";
import ContactInfoSection from "../components/ContactInfoSection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Header avec navigation sémantique */}
      <Header />
      
      {/* Main content avec structure sémantique */}
      <main role="main">
        {/* Hero Section - Section principale */}
        <HeroSection />

        {/* Bandeau saison / tarif en cours */}
        <SeasonBanner />
        
        {/* Section de présentation */}
        <PresentationSection />

        {/* Section Jardin - expérience */}
        <GardenSection />
        
        {/* Section des équipements */}
        <AmenitiesSection />
        
        {/* Section des activités */}
        <ActivitiesSection />
        
        {/* Section des tarifs */}
        <PricingSection />
        
        {/* Section des avis clients */}
        <ReviewsSection />
        
        {/* Section FAQ */}
        <FAQSection />
        
        {/* Section de contact avec formulaire */}
        <ContactFormSection />
        
        {/* Section d'informations de contact avec carte */}
        <ContactInfoSection />
      </main>
      
      {/* Footer avec signature VibeSite */}
      <Footer />
    </div>
  );
};

export default HomePage;